import { render, staticRenderFns } from "./ElementTransfer.vue?vue&type=template&id=316a485f&scoped=true"
import script from "./ElementTransfer.vue?vue&type=script&lang=js"
export * from "./ElementTransfer.vue?vue&type=script&lang=js"
import style0 from "./ElementTransfer.vue?vue&type=style&index=0&id=316a485f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316a485f",
  null
  
)

export default component.exports